import { Company } from "models/Company";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UrlPath } from "utility/routes";
import CompanyAccessItem from "./UserAccess/CompanyAccessItem";
import useAccountData from "hooks/useAccountData";

export default function MyCompanies() {
    const [companies, setCompanies] = useState<Company[] | null>(null);
    const { getCompanies, loadingCompanies} = useAccountData();

    useEffect(() => {
        async function fetchData() {
          if(!loadingCompanies) {
            const response = await getCompanies();
            if(response != null) {
              setCompanies(response);
            }
          }
        }
        fetchData();
        
      }, [getCompanies, loadingCompanies]);

    return (<>
        {loadingCompanies ? (<></>) : (<>
            {companies?.map((_item, _index) => (
            <CompanyAccessItem key={_index} company={_item} />
            ))}
            <p className="mt-4">
            <Link to={UrlPath.MyAccount.AddCompany} className="btn btn-light border">
                <i className="bi bi-plus-lg"></i> Legg til annen bedrift
            </Link>
            </p>
        </>)}
    </>)
}